var exports = {
  "Ef": "UserAreaPopout.module__customStatusRow___RTMtMD",
  "fF": "UserAreaPopout.module__customStatusPlaceholder___RTMtMD",
  "yB": "UserAreaPopout.module__customStatusPlaceholderText___RTMtMD",
  "mo": "UserAreaPopout.module__customStatusPlaceholderIcon___RTMtMD",
  "Ar": "UserAreaPopout.module__copyUsernameButton___RTMtMD",
  "kL": "UserAreaPopout.module__container___RTMtMD",
  "qr": "UserAreaPopout.module__footer___RTMtMD",
  "mH": "UserAreaPopout.module__actionGroup___RTMtMD",
  "Gv": "UserAreaPopout.module__editProfileButton___RTMtMD",
  "hP": "UserAreaPopout.module__actionButton___RTMtMD",
  "k3": "UserAreaPopout.module__actionDivider___RTMtMD",
  "d3": "UserAreaPopout.module__actionButtonDisabled___RTMtMD",
  "gE": "UserAreaPopout.module__actionIcon___RTMtMD",
  "Iz": "UserAreaPopout.module__actionContent___RTMtMD",
  "ZJ": "UserAreaPopout.module__actionLabel___RTMtMD",
  "aN": "UserAreaPopout.module__actionHint___RTMtMD",
  "oS": "UserAreaPopout.module__actionChevron___RTMtMD",
  "qW": "UserAreaPopout.module__statusMenu___RTMtMD" + " " + __webpack_require__(547662)["HG"],
  "C6": "UserAreaPopout.module__expiryPopup___RTMtMD" + " " + __webpack_require__(547662)["HG"],
  "MH": "UserAreaPopout.module__statusMenuRow___RTMtMD",
  "v0": "UserAreaPopout.module__statusMenuItem___RTMtMD" + " " + __webpack_require__(547662)["AS"],
  "Tb": "UserAreaPopout.module__statusMenuIcon___RTMtMD",
  "Te": "UserAreaPopout.module__statusMenuText___RTMtMD",
  "Ye": "UserAreaPopout.module__statusMenuLabel___RTMtMD",
  "wK": "UserAreaPopout.module__statusMenuDescription___RTMtMD" + " " + __webpack_require__(547662)["Lo"],
  "Tc": "UserAreaPopout.module__statusMenuChevron___RTMtMD",
  "L7": "UserAreaPopout.module__expiryItem___RTMtMD" + " " + __webpack_require__(547662)["AS"],
  "ue": "UserAreaPopout.module__expiryLabel___RTMtMD",
};

module.exports = exports;
